export default {
  //   mã GD momo=momo 交易码
  // TK nhận=收款账号
  // TK gửi=转账账号
  // Tên TK=账号名称
  // Gía trị=金额
  // Nội dung=描述
  // Trạng thái=状态
  // Thời gian nhận tiền=时间收款
  // Thời gian quét=时间拉记录

  tranid: 'mã GD momo',
  recordId: 'TK nhận',
  partnerId: 'Tài khoản thanh toán',
  user: 'TK gửi',
  partnerName: 'Tên TK',
  amount: 'Gía trị',
  desc: 'Nội dung',
  status: 'Trạng thái',
  acktime: 'Thời gian nhận tiền',
  createTime: 'Thời gian quét',
  merchantOrderNo: 'Số đơn đặt hàng của người bán',
  systemOrderNo: 'Số thứ tự hệ thống',
  comment: 'Nhận xét',
  no: "số thiết bị"

};



// WEBPACK FOOTER //
// ./src/i18n/lang/vi/momoLogs.js